import { render, staticRenderFns } from "./PageHeaderLayout.vue?vue&type=template&id=365c3d16"
import script from "./PageHeaderLayout.vue?vue&type=script&lang=js"
export * from "./PageHeaderLayout.vue?vue&type=script&lang=js"
import style0 from "./PageHeaderLayout.vue?vue&type=style&index=0&id=365c3d16&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports